import { datadogLogs } from '@datadog/browser-logs';
import { useGetWorkspaceConfig } from '../workspace/useGetWorkspaceConfig';

type GetFullyQualifiedTableNameProps = {
  tableName: string;
  stage: 'bronze' | 'silver' | 'gold';
};

export const useGetFullyQualifiedTableName = ({
  tableName,
  stage,
}: GetFullyQualifiedTableNameProps): { name: string | undefined } => {
  const { data: workspaceConfig, isFetched } = useGetWorkspaceConfig();

  if (!workspaceConfig || !isFetched) {
    return { name: undefined };
  }

  const { datasources = undefined } = workspaceConfig.spec || {};

  if (!datasources) {
    datadogLogs.logger.error('Workspace config is missing datasources');
    return { name: undefined };
  }

  const { catalogName, bronzeSchema, silverSchema, goldSchema } =
    datasources || {};

  if (!catalogName || !bronzeSchema || !silverSchema || !goldSchema) {
    datadogLogs.logger.error(
      `Workspace config is missing a default config: catalogName=${catalogName}, bronzeSchema=${bronzeSchema}, silverSchema=${silverSchema}, goldSchema=${goldSchema}`,
    );
    return { name: undefined };
  }

  switch (stage) {
    case 'bronze':
      return {
        name: `${catalogName}.${bronzeSchema}.${tableName}`,
      };
    case 'silver':
      return {
        name: `${catalogName}.${silverSchema}.${tableName}`,
      };
    case 'gold':
      return {
        name: `${catalogName}.${goldSchema}.${tableName}`,
      };
  }
};
